import React, { Component } from 'react'
import Responsive from '../../components/Responsive'
import { imageAddress, translate } from '../../utils/useful'
// import IconMap from './IconMap'
import DirectoryItem from './directoryItem'

export default class FileUserViewList extends Component {

    state = {
        // filelist: [
        //     { icon: '/assets/icons/drive/csv.svg', name: 'CSV Resume File', type: 'Coral', size: '2233MB' },
        //     { icon: '/assets/icons/drive/pdf.svg', name: 'PDF Resume File', type: 'Serif', size: '2133MB' },
        //     { icon: '/assets/icons/drive/docx.svg', name: 'DOCX Resume File', type: 'Spearmint', size: '513MB' },
        //     { icon: '/assets/icons/drive/crd.svg', name: 'CRD Resume File', type: 'Tropic', size: '73MB' },
        //     { icon: '/assets/icons/drive/psd.svg', name: 'PSD Resume File', type: 'Geometric', size: '2673MB' },
        //     { icon: '/assets/icons/drive/ai.svg', name: 'AI Resume File', type: 'Luxe', size: '2753MB' },
        //     { icon: '/assets/icons/drive/rar.svg', name: 'RAR Resume File', type: 'Luxe', size: '983MB' },
        //     { icon: '/assets/icons/drive/iso.svg', name: 'ISO Resume File', type: 'Luxe', size: '243MB' },
        //     { icon: '/assets/icons/drive/exe.svg', name: 'EXE Resume File', type: 'Luxe', size: '83MB' },
        //     { icon: '/assets/icons/drive/png.svg', name: 'PNG Resume File', type: 'Luxe', size: '113MB' },
        //     { icon: '/assets/icons/drive/gif.svg', name: 'GIF Resume File', type: 'Luxe', size: '467MB' },
        //     { icon: '/assets/icons/drive/jpg.svg', name: 'JPG Resume File', type: 'Luxe', size: '267MB' },
        //     { icon: '/assets/icons/drive/java.svg', name: 'JAVA Resume File', type: 'Luxe', size: '316MB' },
        //     { icon: '/assets/icons/drive/xml.svg', name: 'XML Resume File', type: 'Luxe', size: '3MB' },
        //     { icon: '/assets/icons/drive/html.svg', name: 'HTML Resume File', type: 'Luxe', size: '213MB' },
        // ],
        filesPic: ['png', 'jpg', 'jpeg', 'svg'],

    }

    componentDidMount() {
        if (this.props.setHeader) {
            this.props.setHeader({
                'showSettings': false,
                // backAction: () => this.props.changePage('list')
            })
        }
    }
    openFile = (info) => {
        if (info.type == 'folder') {
            // if(){

            // }
            if (this.props.windowData?.path[this.props.baseUrl?.length] == info.link) {
                this.props.getFiles(info)
            } else {

                this.props.changePage([this.props.page.relatedFrame, info.link])
            }

        } else {
            this.props.changeStage('single')
        }
    }

    render() {
        return (
            <div className="h-100 w-100" >
                {(this.props.driveInfo && this.props.driveInfo.length > 0) ? (
                    <>
                        <div className="Folders h-100 w-100 px-2" style={{}}>
                            {/* {console.log('this.props.driveInfo', element)} */}
                            <div className="Folders directoryViewer w-100">
                                <div className="flexc w-100 pt-3 pb-2 mb-1 bb-gray bg-white" style={{ position: 'sticky', top: '0px', zIndex: 9 }}>
                                    <Responsive height="100%" width={this.props.width} media={{ xs: '9', sm: '6', md: '5', lg: "5", xl: "5" }}>
                                        <div className="font-size-12 main-c4 weight-500 flexc  flex-1">
                                            <p style={{ paddingLeft: '1rem', }}>{translate("drives.Name")}</p>
                                        </div>
                                    </Responsive>
                                    <Responsive height="100%" width={this.props.width} media={{ xs: '3', sm: '3', md: '2', lg: "2", xl: "2" }}>
                                        <div className="font-size-12 main-c4 weight-500 flexcc  flex-1">
                                            <p style={{}}>{translate("drives.Size")}</p>
                                        </div>
                                    </Responsive>
                                    <Responsive height="100%" width={this.props.width} media={{ xs: 'none', sm: '3', md: '2', lg: "2", xl: "2" }}>
                                        <div className="font-size-12 main-c4 weight-500 flexcc  flex-1">
                                            <p style={{}}>{translate("drives.Type")}</p>
                                        </div>
                                    </Responsive>
                                    <Responsive height="100%" width={this.props.width} media={{ xs: 'none', sm: 'none', md: '3', lg: "3", xl: "3" }}>
                                        <div className="font-size-12 main-c4 weight-500 flexcc  flex-1">
                                            <p style={{}}></p>
                                        </div>
                                    </Responsive>
                                </div>
                            </div>

                            {this.props.driveInfo.map((element) => {
                                return (

                                    <div className="Folders w-100 px-2" style={{}}>
                                        {/* {console.log('this.props.driveInfo', element)} */}
                                        <div className="Folders directoryViewer w-100">
                                            <div className='scroll-no-scrollbar w-100' style={{ height: 'calc(100% - 32.8px)' }}>
                                                {/* {this.state.filelist.map((prop, index) => { */}
                                                {/* {this.state.filelist.map((prop, index) => { */}
                                                {/* return ( */}
                                                {/* {this.props.driveInfo && Object.values(this.props.driveInfo).length != 0 && ( */}

                                                <div className='py-1 bb-gray' onDoubleClick={() => this.openFile(element)}>
                                                    <button className="w-100 d-flex flexcc folderHover py-1">
                                                        <Responsive height="100%" width={this.props.width} media={{ xs: '9', sm: '6', md: '5', lg: "5", xl: "5" }}>
                                                            <DirectoryItem
                                                                renameItem={this.props.renameItem}
                                                                item={element}
                                                                currentItem={element}
                                                                onClickItem={() => this.openFile(element)}
                                                                view={'details'}
                                                            />
                                                            {/* <div className='flexc w-100 pld-2'>
                                                <img width={20} src={IconMap[this.props.driveInfo?.extension] ? IconMap[this.props.driveInfo?.extension] : (this.state.filesPic.includes(this.state.file) ? imageAddress(this.props.driveInfo?.address) : '/assets/icons/applets/drive/unknown-file.svg')} />

                                                <p className='mld-4'>{this.props.driveInfo?.name}</p>
                                            </div> */}
                                                        </Responsive>
                                                        <Responsive height="100%" width={this.props.width} media={{ xs: '3', sm: '3', md: '2', lg: "2", xl: "2" }}>
                                                            <div className="flexcc flex-1" style={{}}>
                                                                <p className='flexcc'>{element?.size}</p>
                                                            </div>
                                                        </Responsive>
                                                        <Responsive height="100%" width={this.props.width} media={{ xs: 'none', sm: '3', md: '2', lg: "2", xl: "2" }}>
                                                            <div className="flexcc flex-1" style={{}}>
                                                                <p className='flexcc'>{element?.type}</p>
                                                            </div>
                                                        </Responsive>

                                                        <Responsive height="100%" width={this.props.width} media={{ xs: 'none', sm: 'none', md: '3', lg: "3", xl: "3" }}>
                                                            {element?.type == 'file' ? (
                                                                <div className="flexcc flex-1 prd-2" style={{}}>
                                                                    <div className='w-100 d-flex' style={{ justifyContent: 'flex-end' }}>
                                                                        <button className=' br-8 flexcc' style={{ background: this.props.colors ? this.props.colors?.background : '#f58b00', display: this.props.currentItem?.type === 'folder' && 'none' }}>
                                                                            <img className="p-1" width={22} src="/assets/icons/drive/download-white.svg" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : <></>}
                                                        </Responsive>
                                                    </button>
                                                </div>
                                                {/* )} */}

                                                {/* ) */}
                                                {/* })} */}
                                            </div>
                                        </div>
                                    </div>
                                )

                            })}
                        </div>
                    </>

                ) : (
                    this.empty()
                )}
            </div>
        )
    }
    
    empty = () => {
        return (
            <div className="flexcc p-4 flex-column h-100">
                <img src="/assets/icons/drive/empty-folder.svg" width={100} draggable={false} />
                <div className='mt-3'>
                    <p className="flexcc font-size-14 weight-500" style={{ color: '#222' }}>{translate('drives.No files or folders here')}</p>
                    {/* <p className="flexcc font-size-13 weight-500 mt-1" style={{ color: '#222' }}>{translate('drives.or use New button')}</p> */}
                </div>
            </div>
        )
    }
}
